import { Component, Input } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { HelpPopoverComponent } from './help-popover.component';

@Component({
  selector: 'app-help-icon',
  template: `
    <ion-icon 
      name="information-circle-outline" 
      class="help-icon" 
      (click)="showHelp($event)"
      [title]="translationObject['Hilfe']">
    </ion-icon>
  `,
  styleUrls: ['./help-icon.component.scss']
})
export class HelpIconComponent {
  @Input() helpKey: string = '';
  @Input() translationObject: any = {};

  constructor(private popoverController: PopoverController) {}

  async showHelp(event: any) {
    const popover = await this.popoverController.create({
      component: HelpPopoverComponent,
      componentProps: {
        helpKey: this.helpKey,
        translationObject: this.translationObject
      },
      event: event,
      translucent: true,
      mode: 'ios',
      cssClass: 'help-popover'
    });

    await popover.present();
  }
}
